import { BankIntegrationItem } from "@/types";
import { IntegrationsState } from "./index";

export default {
  setBankList(state: IntegrationsState, payload: BankIntegrationItem[]) {
    state.bankList = payload;
  },
};
